import React, {useEffect, useMemo, useState} from 'react';
import {Route, Switch, useParams} from 'react-router-dom';
import {mainPath} from '../../../routes/paths';
import ProjectsChat from '../ProjectsChat';
import ProjectsReports from '../ProjectsReports';
import ProjectsDocuments from '../ProjectsDocuments';
import ProjectsDrawing from '../ProjectsDrawing';
import ProjectsEstimate from '../ProjectsEstimate';
import ProjectsAssessments from '../ProjectsAssessments';
import ProjectsParticipants from '../ProjectsParticipants';
import ProjectsNotification from '../ProjectsNotification';
import ProjectsEditing from '../ProjectsEditing';
import Menu from '../../Components/Menu';
import {ReactComponent as ProjectIcon1} from '../../../assets/images/Components/Menu/project1.svg';
import {ReactComponent as ProjectIcon2} from '../../../assets/images/Components/Menu/project2.svg';
import {ReactComponent as ProjectIcon3} from '../../../assets/images/Components/Menu/project3.svg';
import {ReactComponent as ProjectIcon4} from '../../../assets/images/Components/Menu/project4.svg';
import {ReactComponent as ProjectIcon5} from '../../../assets/images/Components/Menu/project5.svg';
import {ReactComponent as ProjectIcon6} from '../../../assets/images/Components/Menu/project6.svg';
import {ReactComponent as ProjectIcon7} from '../../../assets/images/Components/Menu/project7.svg';
import {ReactComponent as ProjectIcon8} from '../../../assets/images/Components/Menu/project8.svg';
import {ReactComponent as ProjectIcon9} from '../../../assets/images/Components/Menu/project9.svg';
import {ReactComponent as ProjectIcon10} from '../../../assets/images/Components/Menu/project10.svg';
import {ReactComponent as ProjectIcon11} from '../../../assets/icons/paused.svg';
import {ReactComponent as ProjectIcon12} from '../../../assets/icons/started.svg';
import {ReactComponent as ProjectIcon13} from '../../../assets/icons/play.svg';

import {useDispatch, useSelector} from 'react-redux';
import {
    downloadProject,
    finishProject,
    getProject,
    getProjects,
    pauseProject,
    resetProject,
    resumeOrStartProject
} from '../../../redux/actions/projects/projectsActions';
import LoadPanel from '../../Components/LoadPanel';
import {clearReports} from '../../../redux/actions/reports/reportsActions';
import {resetAllDocuments} from '../../../redux/actions/documents/documentsActions';
import {clearEmployee} from '../../../redux/actions/employee/employeeActions';
import {clearClients} from '../../../redux/actions/clients/clientsActions';
import {hasPermission} from '../../../helpers/functions';
import {PERMISSIONS} from '../../../helpers/constants';
import {useTranslation} from 'react-i18next';
import {closeModal, setModal, showConfirmPopup} from '../../../redux/actions/app/appActions';
import {POPUPS} from '../../../redux/actions/app/appActionTypes';
import ProjectParticipantsInnerEmployee from '../ProjectsParticipants/ProjectParticipantsInnerEmployee';
import ProjectsParticipantsAdd from '../../Components/Projects/ProjectsParticipantsAdd';
import ProjectParticipantsInnerClients from '../ProjectsParticipants/ProjectParticipantsClients';

const ProjectsInner = ({
                           handleNavLinkClick,
                           toggleYourContent,
                           isYourContentVisible,
                           isMenuVisible,
                           isInnerVisible
                       }) => {
    const dispatch = useDispatch();
    const {singleProjectLoading, singleProject} = useSelector((state) => state.projects);
    const {profileMe} = useSelector((state) => state.profile);

    const {id} = useParams();
    const {t} = useTranslation();
    const defaultChat = singleProject?.chats ? singleProject?.chats[0] : [];
    const companyChat = singleProject?.chats ? singleProject?.chats[1] : [];

    const permissionEdit = hasPermission(PERMISSIONS.PROJECT_EDIT, profileMe?.permissions ?? []);
    const permissionViewEstimate = hasPermission(PERMISSIONS.ESTIMATE_LIST, profileMe?.permissions ?? []);
    const permissionChat = profileMe?.role !== 'demo' && profileMe?.role !== 'financier';
    const permissionReports = hasPermission(PERMISSIONS.REPORT_VIEW, profileMe?.permissions ?? []);
    const permissionDrawing = hasPermission(PERMISSIONS.DRAWING_LIST, profileMe?.permissions ?? []);
    const permissionDocument = hasPermission(PERMISSIONS.DOCUMENT_LIST, profileMe?.permissions ?? []);
    const permissionAsessments = profileMe?.role !== 'financier'
    const permissionNofification = profileMe?.role !== 'financier'
    const permissionMembers = profileMe?.role !== 'financier'
    const menuList = useMemo(() => {
        const list = [
            ...(permissionChat
                ? [
                    {
                        name: t('ProjectsInner.chat'),
                        icon: <ProjectIcon1/>,
                        companiesChat: companyChat?.messageUnreadCount,
                        generalChat: defaultChat?.messageUnreadCount,
                        link: mainPath.projectsChat.replace(':id', id)
                    }
                ]
                : []),
            ...(permissionReports ? [{
                name: t('ProjectsInner.reports'),
                icon: <ProjectIcon2/>,
                count: singleProject?.statistics?.reports ?? null,
                notification: singleProject?.statistics?.newReports ?? null,
                link: `${mainPath.projectsReports.replace(':id', id)}?type=1`
            }] : []),
            ...(permissionDocument ? [{
                name: t('ProjectsInner.documents'),
                icon: <ProjectIcon3/>,
                count: singleProject?.statistics?.documents ?? null,
                notification: singleProject?.statistics?.newDocuments ?? null,
                link: mainPath.projectsDocuments.replace(':id', id)
            }] : []),
            ...(permissionDrawing ? [{
                name: t('ProjectsInner.drawings'),
                icon: <ProjectIcon4/>,
                count: singleProject?.statistics?.drawings ?? null,
                notification: singleProject?.statistics?.newDrawings ?? null,
                link: mainPath.projectsDrawing.replace(':id', id)
            }] : []),
            ...(permissionViewEstimate
                ? [
                    {
                        name: t('ProjectsInner.estimates'),
                        icon: <ProjectIcon5/>,
                        count: singleProject?.statistics?.estimates ?? null,
                        link: mainPath.projectsEstimate.replace(':id', id)
                    }
                ]
                : []),
            ...(permissionAsessments ? [
                {
                    name: t('ProjectsInner.assessments'),
                    icon: <ProjectIcon6/>,
                    link: mainPath.projectsAssessments.replace(':id', id)
                }
            ] : []),
            ...(permissionMembers ? [{
                name: t('ProjectsInner.participants'),
                icon: <ProjectIcon7/>,
                count: singleProject?.statistics?.members ?? null,
                link: mainPath.projectsParticipants.replace(':id', id)
            }] : []),
            ...(permissionNofification ? [
                {
                    name: t('ProjectsInner.notifications'),
                    icon: <ProjectIcon8/>,
                    link: mainPath.projectsNotification.replace(':id', id)
                }
            ] : []),
        ];

        if (profileMe?.role === 'user' || profileMe?.role === 'spectator') {
            return list;
        }
        if (permissionEdit) {
            list.push({
                name: t('ProjectsInner.editing'),
                icon: <ProjectIcon9/>,
                link: mainPath.projectsEditing.replace(':id', id)
            });
        }

        return list;
    }, [id, singleProject, t, permissionViewEstimate]);

    useEffect(() => {
        const controller = new AbortController();
        const {signal} = controller;

        const fetchFunc = async () => {
            await dispatch(getProject(id, false, signal));
        };
        fetchFunc();

        return () => {
            controller.abort();
            dispatch(resetProject());
            dispatch(clearReports());
            dispatch(resetAllDocuments());
            dispatch(clearEmployee());
            dispatch(clearClients());
        };
    }, [id]);

    const [clicked, setClicked] = useState(false);

    const permissionPauseResume =
        hasPermission(PERMISSIONS.PROJECT_PAUSE, profileMe?.permissions ?? []) &&
        hasPermission(PERMISSIONS.PROJECT_RESUME, profileMe?.permissions ?? []);

    const permissionDoneProject = hasPermission(PERMISSIONS.PROJECT_FINISH, profileMe?.permissions ?? []);

    const muteHandler = async () => {
        try {
            if (!clicked) {
                const res = await dispatch(pauseProject(id));
                if (res?.payload) {
                    setClicked(false);
                    await dispatch(getProjects(true));
                    await dispatch(getProject(id, true));
                } else {
                    setClicked(false);
                }
            }
        } catch (err) {
            setClicked(true);
            console.log('error', err);
        }
    };

    const resumeHandler = async () => {
        try {
            if (!clicked) {
                setClicked(true);
                const res = await dispatch(resumeOrStartProject(id));
                if (res?.payload) {
                    setClicked(false);
                    await dispatch(getProjects(true));
                    await dispatch(getProject(id, true));
                } else {
                    setClicked(false);
                }
            }
        } catch (err) {
            setClicked(false);
            console.log('error', err);
        }
    };

    const confirmHandler = async () => {
        try {
            if (!clicked) {
                setClicked(true);
                const res = await dispatch(finishProject(id));
                if (res?.payload) {
                    await dispatch(getProjects(true));
                    await dispatch(getProject(id, true));
                } else {
                    setClicked(false);
                }
            }
        } catch (err) {
            setClicked(false);
            console.log('error', err);
        }
    };

    const muteHandlerRedux = () => {
        dispatch(
            showConfirmPopup({
                visible: true,
                title: t('project.muteTitle'),
                text: t('project.muteText'),
                confirmCallback: muteHandler
            })
        );
    };

    const resumeHandlerRedux = () => {
        dispatch(
            showConfirmPopup({
                visible: true,
                title: t('project.resumeTitle'),
                text: t('project.resumeText'),
                confirmCallback: resumeHandler
            })
        );
    };

    const confirmHandlerRedux = () => {
        dispatch(
            showConfirmPopup({
                visible: true,
                title: t('project.confirmTitle'),
                text: t('project.confirmText'),
                confirmCallback: confirmHandler
            })
        );
    };

    return (
        <>
            {isMenuVisible && (
                <Menu
                    title={t('ProjectsInner.title')}
                    back={t('ProjectsInner.back')}
                    menuList={menuList}
                    toggleYourContent={toggleYourContent}
                    handleNavLinkClick={handleNavLinkClick}
                    isYourContentVisible={isYourContentVisible}
                    additionalMenuItems={
                        <>
                            {hasPermission(PERMISSIONS.PROJECT_DOWNLOAD, profileMe?.permissions ?? []) && (
                                <div className='items'>
                                    <div
                                        className='items__blocks'
                                        onClick={() => {
                                            dispatch(setModal(POPUPS.PREPARING_POPUP));
                                            dispatch(downloadProject(id)).then((res) => {
                                                if (res.payload) {
                                                    const link = document.createElement('a');
                                                    link.href = URL.createObjectURL(res.payload.data);
                                                    link.download = singleProject?.address + '.zip';

                                                    document.body.appendChild(link);

                                                    link.click();
                                                    link.parentNode.removeChild(link);
                                                    dispatch(closeModal());
                                                }
                                            });
                                        }}
                                    >
                                        <ProjectIcon10/>
                                        <div className='items__name'>{t('ProjectsInner.download')}</div>
                                    </div>
                                </div>
                            )}
                            {singleProject?.status === 'active' && permissionPauseResume && (
                                <div className='items items--mute' onClick={muteHandlerRedux}>
                                    <ProjectIcon11/>
                                    <div className='items__name'>{t('ProjectsInner.pause')}</div>
                                </div>
                            )}
                            {singleProject?.status === 'pause' && permissionPauseResume && (
                                <div className='items items--resume' onClick={resumeHandlerRedux}>
                                    <ProjectIcon13/>
                                    <div className='items__name'>{t('ProjectsInner.resume')}</div>
                                </div>
                            )}
                            {(singleProject?.status === 'active' || singleProject?.status === 'pause') && permissionDoneProject && (
                                <div className='items items--done' onClick={confirmHandlerRedux}>
                                    <ProjectIcon12/>
                                    <div className='items__name'>{t('ProjectsInner.finish')}</div>
                                </div>
                            )}
                        </>
                    }
                    disabled={singleProjectLoading}
                />
            )}

            {singleProjectLoading ? (
                <div className={'companies-page-loader companies-page-loader-main'}>
                    <LoadPanel noBg={true} circleSize={50} staticPos={true}/>
                </div>
            ) : (
                <>
                    {isInnerVisible && (
                        <Switch>
                            <Route path={mainPath.projectsChat} component={ProjectsChat}/>
                            <Route path={mainPath.projectsReports} component={ProjectsReports}/>
                            <Route path={mainPath.projectsDocument} component={ProjectsDocuments}/>
                            <Route path={mainPath.projectsDocuments} component={ProjectsDocuments}/>
                            <Route path={mainPath.projectDrawing} component={ProjectsDrawing}/>
                            <Route path={mainPath.projectsDrawing} component={ProjectsDrawing}/>
                            <Route path={mainPath.projectEstimate} component={ProjectsEstimate}/>
                            <Route path={mainPath.projectsEstimate} component={ProjectsEstimate}/>
                            <Route path={mainPath.projectsAssessments} component={ProjectsAssessments}/>
                            <Route path={mainPath.projectsParticipantsAdd} component={ProjectsParticipantsAdd}/>
                            <Route path={mainPath.projectsParticipantsEmployee}
                                   component={ProjectParticipantsInnerEmployee}/>
                            <Route path={mainPath.projectsParticipantsClient}
                                   component={ProjectParticipantsInnerClients}/>
                            <Route path={mainPath.projectsParticipants} component={ProjectsParticipants}/>
                            <Route path={mainPath.projectsNotification} component={ProjectsNotification}/>
                            <Route path={mainPath.projectsEditing} component={ProjectsEditing}/>
                        </Switch>
                    )}
                </>
            )}
        </>
    );
};

export default ProjectsInner;
